import { ClipLoader } from "react-spinners";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  actionType: "activate" | "suspend";
  userName: string;
  isLoading: boolean;
}

export const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  actionType,
  userName,
  isLoading,
}: ConfirmationModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 p-2 bg-gray-800 bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <p className="text-lg font-semibold mb-4">
          {actionType === "suspend"
            ? `Suspend ${userName}?`
            : `Activate ${userName}?`}
        </p>
        <div className="flex justify-end space-x-3">
          <button onClick={onClose} className="px-4 py-2 rounded-lg">
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-2 rounded-lg text-white flex items-center justify-center ${
              actionType === "suspend" ? "bg-rose-500" : "bg-emerald-500"
            }`}
            disabled={isLoading}
          >
            {isLoading ? <ClipLoader size={20} color="white" /> : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};
